import React from "react";
import Map, { Marker } from "react-map-gl";

import MarkerIcon from "../../assets/img/icons/marker.png";

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_API_TOKEN;

export const MapTourist = ({ lat, lng, zoom, width, height }) => {
  return (
    <div className="mt-3">
      <Map
        initialViewState={{
          longitude: lng,
          latitude: lat,
          zoom: 14,
        }}
        style={{ width: width, height: height ,zIndex:"0", }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        mapboxAccessToken={MAPBOX_TOKEN}
      >
        <Marker longitude={lng} latitude={lat} anchor="bottom">
          <img src={MarkerIcon} width={50} alt="Marker icon" />
        </Marker>
      </Map>
    </div>
  );
};
